import React from 'react'
import Wrapper from './wrapper'

type DescriptionProps = {
  data: string
  label: string
}

const Description: React.FC<DescriptionProps> = ({ data, label }) => {
  const createMarkup = (content: string) => ({ __html: content })
  const formattedData = typeof data === 'string' ? data : ''

  return (
    <Wrapper>
      <div className="p-4 description">
        <h2 className="mb-2 text-lg font-semibold text-night">{label}</h2>
        <div
          className="lg:text-[16px] text-[14px] text-night"
          dangerouslySetInnerHTML={createMarkup(
            formattedData.replace(/\n/g, '<br />'),
          )}
        />
      </div>
    </Wrapper>
  )
}

export default Description
